var React = require('react');

function IconArrow2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"icon_arrow2","d":"M400,14150.137l33.472,33.472L400,14217.08","transform":"translate(-399.47 -14149.606)","fill":"none","stroke":"#2a2c2b","strokeWidth":"1.5"}));
}

IconArrow2.defaultProps = {"width":"35.063","height":"68.004","viewBox":"0 0 35.063 68.004"};

module.exports = IconArrow2;

IconArrow2.default = IconArrow2;
